"use strict";import{html as i}from"@cisco-u/base";export function aiLogoLarge({height:t="100%",width:e=164,hidden:a=!1,title:o=""}={}){return i`<svg
    xmlns="http://www.w3.org/2000/svg"
    width=${e}
    height=${t}
    viewBox="0 0 164 164"
    fill="none"
    aria-hidden="${a?"true":"false"}"
    aria-label="${o}"
  >
    <path
      d="M120.438 92.25C141.666 92.25 158.875 75.041 158.875 53.8125C158.875 32.584 141.666 15.375 120.438 15.375C99.209 15.375 82 32.5841 82 53.8125C82 75.0409 99.209 92.25 120.438 92.25Z"
      fill="url(#paint0_linear_231_16401)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M82 43.1665C60.5357 43.1665 43.1354 60.5618 43.1354 82.0199C43.1354 103.478 60.5357 120.873 82 120.873C103.464 120.873 120.865 103.478 120.865 82.0199C120.865 60.5618 103.464 43.1665 82 43.1665ZM15.375 82.0199C15.375 45.2345 45.204 15.4141 82 15.4141C118.796 15.4141 148.625 45.2345 148.625 82.0199C148.625 118.805 118.796 148.626 82 148.626C45.204 148.626 15.375 118.805 15.375 82.0199Z"
      fill="url(#paint1_linear_231_16401)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M148.589 79.9765C141.573 87.5034 131.57 92.2101 120.468 92.2101C120.147 92.2101 119.827 92.2062 119.508 92.1984C120.394 88.9423 120.866 85.5162 120.866 81.9798C120.866 61.0251 104.277 43.9449 83.5156 43.1549C86.5683 32.5112 94.0954 23.759 103.931 19.0645C129.35 27.9188 147.755 51.7422 148.589 79.9765Z"
      fill="url(#paint2_linear_231_16401)"
    />
    <path
      d="M120.418 92.25C141.646 92.25 158.855 75.041 158.855 53.8125C158.855 32.584 141.646 15.375 120.418 15.375C99.1895 15.375 81.9805 32.5841 81.9805 53.8125C81.9805 75.0409 99.1895 92.25 120.418 92.25Z"
      fill="url(#paint3_radial_231_16401)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_231_16401"
        x1="83.5244"
        y1="15.375"
        x2="146.467"
        y2="78.3178"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0087EA" />
        <stop offset="1" stop-color="#63FFF7" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_231_16401"
        x1="148.625"
        y1="15.4141"
        x2="15.4133"
        y2="148.664"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0051AF" />
        <stop offset="0.666238" stop-color="#0087EA" />
        <stop offset="1" stop-color="#00BCEB" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_231_16401"
        x1="107.344"
        y1="40.949"
        x2="142.978"
        y2="82.1628"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#74BF4B" stop-opacity="0" />
        <stop offset="1" stop-color="#74BF4B" />
      </linearGradient>
      <radialGradient
        id="paint3_radial_231_16401"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(158.855 92.25) rotate(-135) scale(108.718 108.672)"
      >
        <stop stop-color="#00BCEB" stop-opacity="0" />
        <stop offset="0.666962" stop-color="#00BCEB" stop-opacity="0" />
        <stop offset="1" stop-color="#00BCEB" />
      </radialGradient>
    </defs>
  </svg>`}
//# sourceMappingURL=ai-logo-large.js.map
